import { Stack, Typography, Switch } from "@mui/material";
import { useCallback, ChangeEvent } from "react";
import { useUpdateProviderLicenseMutation } from "src/api/services/providersApi";
import { ProviderLicense } from "src/api/types";
import { statesMap } from "src/constants/usStates";

interface Props {
  license: ProviderLicense;
}

const License = ({ license }: Props) => {
  const [updateLicense] = useUpdateProviderLicenseMutation();
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      updateLicense({
        provider_id: license.provider_id,
        state_code: license.state_code,
        updates: {
          active: event.target.checked,
        },
      });
    },
    [license.provider_id, license.state_code, updateLicense]
  );

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography id={`label-${license.state_code}`}>
        {statesMap[license.state_code]}
      </Typography>
      <Switch
        color="secondary"
        checked={license.active}
        onChange={handleChange}
      />
    </Stack>
  );
};

export default License;
